import React, { ReactElement } from 'react'
import styled from '@emotion/styled'
import Loader from '@mindfulchefuk/components/Loader'
import { Box, Grid, Modal, ModalHeader } from '@mindfulchefuk/design-system'
import { logModalClose } from '@mindfulchefuk/features/Onboarding/utils/onboardingAnalytics'
import {
  DeliveryRecipe,
  RecipeWithQuantity,
} from '@mindfulchefuk/features/Recipes/interfaces'
import { closeModal } from '@mindfulchefuk/utils/modalUtils'
import { RecipeModalTrustpilotFooter } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalTrustpilotFooter'
import { RecipeModalLeftSide } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalLeftSide'
import { RecipeModalRightSide } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalRightSide'
import { RecipeModalTitle } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalTitle'

export type TRecipeModalProps = {
  isAdditionDisabled?: boolean
  isWithinOrderWindow?: boolean
  onBackClick?: () => void
  onClose?: () => void
  onDecrement?: (recipe: RecipeWithQuantity) => void
  onIncrement?: (
    recipe: RecipeWithQuantity,
    isRecipeRecommended: boolean
  ) => void
  recipe: RecipeWithQuantity | DeliveryRecipe
  withCookingInstructions?: boolean
}

const HeaderWrapper = styled('div')`
  @media screen and (min-width: 640px) {
    display: none;
  }
`

const Header = ({ title }: { title: string }) => {
  return (
    <HeaderWrapper>
      <RecipeModalTitle title={title} />
    </HeaderWrapper>
  )
}

export const RecipeModal = ({
  isAdditionDisabled = false,
  isWithinOrderWindow = true,
  onBackClick,
  onClose,
  onDecrement,
  onIncrement,
  recipe,
  withCookingInstructions,
}: TRecipeModalProps): ReactElement => {
  if (!recipe)
    return (
      <Modal size="large">
        <Box height="95vh" width="100%">
          <Loader />
        </Box>
      </Modal>
    )

  const handleRecipeModalClose = () => {
    closeModal('recipe')
    onClose?.()
    logModalClose()
  }

  return (
    <Modal size="large" closeModal={handleRecipeModalClose}>
      <ModalHeader closeModal={handleRecipeModalClose} goBack={onBackClick}>
        {!onBackClick && <Header title={recipe.title} />}
      </ModalHeader>
      <Grid
        templateColumns={['1fr', '1fr 1fr']}
        color="aubergine"
        columnGap={12}
      >
        <RecipeModalLeftSide recipe={recipe} />
        <RecipeModalRightSide
          isAdditionDisabled={isAdditionDisabled}
          isWithinOrderWindow={isWithinOrderWindow}
          recipe={recipe}
          onDecrement={onDecrement}
          onIncrement={onIncrement}
          withCookingInstructions={withCookingInstructions}
        />
      </Grid>
      <RecipeModalTrustpilotFooter />
    </Modal>
  )
}
